// extracted by mini-css-extract-plugin
export default {"container":"Button_container__k+zfJ","loading":"Button_loading__d8TtY","outlined":"Button_outlined__io8RJ","error":"Button_error__FtLok"};